import { Client, Account, Databases } from "appwrite";

const client = new Client();

client
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT)
  .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID);

// ✅ Core services
export const account = new Account(client);
export const databases = new Databases(client);

// ✅ ADD THESE BACK (THIS IS WHAT YOU LOST)
export const DATABASE_ID = "69cdbbbf00117a34128c";

export const COLLECTIONS = {
  EVENTS: "events",
  SCORES: "scores",
  GALLERY: "gallery",
};